import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-class-arrow",
  "use": "icon-class-arrow-usage",
  "viewBox": "0 0 1797 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1797 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-class-arrow\"><defs><style type=\"text/css\"></style></defs><path d=\"M751.452892 61.471875L40.731984 786.187875a139.533157 139.533157 0 0 0 97.025676 237.812125H1656.434034a139.533157 139.533157 0 0 0 96.503471-237.498802L1042.216597 61.785198A202.302189 202.302189 0 0 0 751.452892 61.471875z\" p-id=\"4246\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol